import React from 'react'
import { Select, DatePicker } from 'antd'
import dayjs from 'dayjs'
import CustomersDropdown from '../../components/CustomersDropdown'
import PlatformsDropdown from '../../components/PlatformsDropdown'
import {
  REPORTS_WITH_CUSTOMER,
  REPORTS_WITH_PLATFORM,
  REPORTS_WITH_LINK_STATUS,
  REPORTS_WITH_DATES,
  REPORTS_WITH_DATE_FIELD
} from './reportConfig'

function ReportFormFields ({ reportId, validation }) {
  return (
    <>
      {REPORTS_WITH_CUSTOMER.includes(reportId) && (
        <div>
          <CustomersDropdown
            isAll={true}
            onChange={(e, options) => {
              validation.setFieldValue('customer', options.value)
            }}
            onBlur={validation.handleBlur}
            value={validation.values.customer}
            className='customSelect'
          />
          {validation?.touched?.customer && validation?.errors?.customer ? (
            <p className='text-danger'>{validation?.errors?.customer}</p>
          ) : null}
        </div>
      )}

      {REPORTS_WITH_PLATFORM.includes(reportId) && (
        <div>
          <PlatformsDropdown
            isAll={true}
            onBlur={validation.handleBlur}
            value={validation.values.platform}
            multi={false}
            onChange={(e, option) => {
              validation.setFieldValue('platform', option.value)
            }}
            className='customSelect'
          />
          {validation?.touched?.platform && validation?.errors?.platform ? (
            <p className='text-danger'>{validation?.errors?.platform}</p>
          ) : null}
        </div>
      )}

      {REPORTS_WITH_LINK_STATUS.includes(reportId) && (
        <div>
          <div className=' mb-3'>
            <label className=''>Link Status</label>
            <br />
            <Select
              className='customSelect'
              style={{
                width: '100%'
              }}
              placeholder='Please select'
              onBlur={validation.handleBlur}
              value={validation.values.link_status}
              onChange={(e, option) => {
                validation.setFieldValue('link_status', option.value)
              }}
              options={[
                {
                  label: 'monetized',
                  value: 'monetized'
                },
                {
                  label: 'retracted',
                  value: 'retracted'
                }
              ]}
            />
          </div>
        </div>
      )}

      {REPORTS_WITH_DATE_FIELD.includes(reportId) && (
        <div className='mb-3'>
          <label>Date Field</label>
          <br />
          <Select
            className='customSelect'
            style={{ width: '100%' }}
            placeholder='Select date field'
            onBlur={validation.handleBlur}
            value={validation.values.date_field || undefined}
            onChange={value => validation.setFieldValue('date_field', value)}
            options={[
              { label: 'Report Date', value: 'report_date' },
              { label: 'Insertion Date', value: 'insertion_date' }
            ]}
          />
          {validation?.touched?.date_field && validation?.errors?.date_field ? (
            <p className='text-danger'>{validation.errors.date_field}</p>
          ) : null}
        </div>
      )}

      {REPORTS_WITH_DATES.includes(reportId) && (
        <div>
          <div>
            <div className=' mb-3 customeDate'>
              <label className=''>Start Date</label>
              <br />
              <DatePicker
                name='report_date'
                onChange={(e, date) =>
                  validation.setFieldValue('start_date', date)
                }
                onBlur={validation.handleBlur}
                value={
                  validation.values.start_date
                    ? dayjs(validation.values.start_date)
                    : ''
                }
              />
            </div>
            {validation.touched.start_date && validation.errors.start_date ? (
              <p className='text-danger'>{validation.errors.start_date}</p>
            ) : null}
          </div>
          <div>
            <div className=' mb-3 customeDate'>
              <label className=''>End Date</label>
              <br />
              <DatePicker
                name='end_date'
                onChange={(e, date) =>
                  validation.setFieldValue('end_date', date)
                }
                onBlur={validation.handleBlur}
                value={
                  validation.values.end_date
                    ? dayjs(validation.values.end_date)
                    : ''
                }
              />
            </div>
            {validation.touched.end_date && validation.errors.end_date ? (
              <p className='text-danger'>{validation.errors.end_date}</p>
            ) : null}
          </div>
        </div>
      )}
    </>
  )
}

export default ReportFormFields
